// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PNotificationOutlinedSvg from "@fishx/icons-svg/es/asn/PNotificationOutlined";
import FishxIcon from '../components/FishxIcon';

var PNotificationOutlined = function PNotificationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PNotificationOutlinedSvg
  }));
};

PNotificationOutlined.displayName = 'PNotificationOutlined';
export default React.forwardRef(PNotificationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PNotificationOutlined.js
// module id = 3517
// module chunks = 0